
import { api } from "@/utils/request";

export default {
  name: 'HomePage',
  data() {
    return {
      isCarouselReady: false,
      featuredMediaData: [],
      mediaLimit: 6,
      videoData: [],
      videoLength: 0,
      eventData: [],
      eventLength: 0,
      articleData: [],
      articleLength: 0,
      searchInput: '',
      isEmptyVideo: false,
      isEmptyEvent: false,
      isEmptyArticle: false,
    };
  },
  computed: {
    getAllSearchLength() {
      return this.videoLength + this.articleLength + this.eventLength
    }
  },
  methods: {
    onInitCarousel () {
      this.isCarouselReady = true
    },
    searchMedia(input) {
      this.searchInput = input;
      this.fetchVideoList(input)
      this.fetchEventList(input)
      this.fetchArticleList(input)
    },
    searchByCategory(val) {
      this.searchInput = '';
      this.fetchVideoList('', val)
      this.fetchEventList('', val)
      this.fetchArticleList('', val)
    },
    async fetchFeaturedMediaList() {
      try {
        const medias = await api('featured-homepage')
        if (medias && medias.result) {
          this.featuredMediaData = medias.result;
        }
      } catch (e) {
        console.error(e)
      }
    },
    async fetchVideoList(search= '', category= '') {
      this.videoData = [];
      this.isEmptyVideo = false;
      try {
        const reqParams = {
          page: 1,
          perPage: this.mediaLimit,
          mediaType: 'VIDEO',
        }

        if (category) reqParams.category = category;
        if (search) reqParams.search = search;

        const medias = await api('medias', reqParams)
        if (medias && medias.result) {
          const media = medias.result.medias
          this.videoData = media;
          this.videoLength = media.length;
          this.isEmptyVideo = !this.videoLength;
        }
      } catch (e) {
        this.videoData = [];
        this.isEmptyVideo = true;
      }
    },
    async fetchEventList(search= '', category= '') {
      this.eventData = [];
      this.isEmptyEvent = false;
      try {
        const reqParams = {
          page: 1,
          perPage: this.mediaLimit,
          mediaType: 'LIVE',
        }

        if (category) reqParams.category = category;
        if (search) reqParams.search = search;

        const medias = await api('medias', reqParams)
        if (medias && medias.result) {
          const media = medias.result.medias
          this.eventData = media;
          this.eventLength = media.length;
          this.isEmptyEvent = !this.eventLength;
        }
      } catch (e) {
        this.eventData = [];
        this.isEmptyEvent = true;
      }
    },
    async fetchArticleList(search= '', category= '') {
      this.articleData = [];
      this.isEmptyArticle = false;
      try {
        const reqParams = {
          page: 1,
          perPage: this.mediaLimit,
        }

        if (category) reqParams.category = category;
        if (search) reqParams.search = search;

        const medias = await api('blogs', reqParams)
        if (medias && medias.result) {
          const media = medias.result.blogs
          this.articleData = media;
          this.articleLength = media.length;
          this.isEmptyArticle = !this.articleLength;
        }
      } catch (e) {
        this.articleData = [];
        this.isEmptyArticle = true;
      }
    },
  },
  created() {
    this.fetchFeaturedMediaList()
    this.fetchVideoList()
    this.fetchEventList()
    this.fetchArticleList()
  },
}
